class Analytics {
  sendEvent = (eventName: string, eventParameters = {}) => {
    // eslint-disable-next-line no-console
    console.log(`%c Analytics: ${eventName} `, 'color: white; background: red', eventParameters);

    // @ts-ignore
    window.gtag && window.gtag('event', eventName, eventParameters);
  };
}

export default new Analytics();
